import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { executeOnSingleOrMultiple } from "../../../../Utils/Utils";
export var DivEvent = /*#__PURE__*/function () {
  function DivEvent() {
    _classCallCheck(this, DivEvent);

    this.selectors = [];
    this.enable = false;
    this.mode = [];
    this.type = "circle";
  }

  _createClass(DivEvent, [{
    key: "el",
    get: function get() {
      return this.elementId;
    },
    set: function set(value) {
      this.elementId = value;
    }
  }, {
    key: "elementId",
    get: function get() {
      return this.ids;
    },
    set: function set(value) {
      this.ids = value;
    }
  }, {
    key: "ids",
    get: function get() {
      return executeOnSingleOrMultiple(this.selectors, function (t) {
        return t.replace("#", "");
      });
    },
    set: function set(value) {
      this.selectors = executeOnSingleOrMultiple(value, function (t) {
        return "#".concat(t);
      });
    }
  }, {
    key: "load",
    value: function load(data) {
      var _ref, _data$ids;

      if (!data) {
        return;
      }

      var ids = (_ref = (_data$ids = data.ids) !== null && _data$ids !== void 0 ? _data$ids : data.elementId) !== null && _ref !== void 0 ? _ref : data.el;

      if (ids !== undefined) {
        this.ids = ids;
      }

      if (data.selectors !== undefined) {
        this.selectors = data.selectors;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.mode !== undefined) {
        this.mode = data.mode;
      }

      if (data.type !== undefined) {
        this.type = data.type;
      }
    }
  }]);

  return DivEvent;
}();